import { render, staticRenderFns } from "./ButtonWebCall.vue?vue&type=template&id=8e8a7368&scoped=true"
import script from "./ButtonWebCall.vue?vue&type=script&lang=js"
export * from "./ButtonWebCall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e8a7368",
  null
  
)

export default component.exports